import { forwardRef } from 'react';
import { Portal } from 'react-portal';

import type { BoxProps } from '@hivebrite/design-system/Box';
import { Modal } from '@hivebrite/design-system/Dialog';
import type { ModalElement } from '@hivebrite/design-system/Dialog';

import useFrameTheme from 'hb-react/shared/hooks/theme/useFrameTheme';
import ThemeProvider from 'hb-react/style/ThemeProvider';

import type { ModalWithTemplateProps } from '../types';

export default forwardRef<
  ModalElement,
  ModalWithTemplateProps & {
    footProps?: BoxProps;
    isFixed?: boolean;
    isOpen: boolean;
    isSticky?: boolean;
  }
>(
  (
    {
      center,
      children,
      customHeight,
      customZIndex,
      dataTestId,
      enableEscAction,
      footer,
      footProps,
      header,
      isFixed,
      isLoading,
      isOpen,
      isSticky,
      onCloseModal,
      pb,
      pl,
      pr,
      pt,
      screenReadersCloseButtonText,
      width,
    },
    ref,
  ) => {
    const frameTheme = useFrameTheme();

    return (
      <Portal>
        <ThemeProvider
          fontBrightness={frameTheme.fontBrightness}
          theme={frameTheme.themeName}
        >
          <Modal
            bg={frameTheme.backgroundColor}
            canDismissOnEsc={enableEscAction}
            center={center}
            closeButtonText={screenReadersCloseButtonText}
            dataTestId={dataTestId}
            footer={footer}
            footProps={footProps}
            header={header}
            height={customHeight}
            isFixed={isFixed}
            isLoading={isLoading}
            isOpen={isOpen}
            isSticky={isSticky}
            onDismiss={onCloseModal}
            pb={pb}
            pl={pl}
            pr={pr}
            pt={pt}
            // To be fixed when we choose between the two or make a V3.
            // @ts-expect-error V1 and V2 types are incompatible.
            ref={ref}
            width={width}
            zIndex={customZIndex}
          >
            {children}
          </Modal>
        </ThemeProvider>
      </Portal>
    );
  },
);
